interface ExtractedEntity {
  provider_entity: string;
  s3_url?: string;
}

export const getTransformEntities = (
  providerName: string,
  entities: ExtractedEntity[],
): ExtractedEntity[] =>
  providerName === 'SALESFORCE'
    ? entities.filter(({ provider_entity }) => provider_entity !== 'SALESFORCE_DEALS_CONTACTS')
    : entities;
